export default "__VITE_ASSET__xHK108qn__"